import React, { useEffect } from 'react'
import { Route, Redirect, withRouter } from 'react-router-dom'
import { getUser } from '../utilties/userUtilities'
import queryString from 'query-string'
import { get } from '../utilties/cookies'
import PageWrapper from '../components/PageWrapper'
import { isMobile } from '../utilties/mobileDetector'

const PrivateRoute = ({ component: Component, location, allowExternalAuth, ua, title, gaPageTitle, ...rest }) => {
	const user = getUser()
	let params = queryString.parse(location.search)

	const renderRoute = (props) => {
		const continueWithBrowser = get('continueWithBrowser')

		if (
			isMobile
			&& !window.navigator.userAgent.includes('BenchmarcApp')
			&& !Boolean(continueWithBrowser)
		) {
			if (!!window.location && !window.location.pathname.includes('installApp')) {
				const returnUrl = encodeURIComponent(`${window.location.pathname}${window.location.search}`)

				return (
					<Redirect
						to={{
							pathname: '/installApp',
							search: `?returnUrl=${returnUrl}`
						}}
					/>
				)
			}
			else {
				return (
					<Redirect
						to={{
							pathname: '/installApp'
						}}
					/>
				)
			}
		} else if (params.patient || user && user.id && (!user.externalAuth || allowExternalAuth)) {
			if (params.patient || user.termsAccepted || (user && user.externalAuth && allowExternalAuth)) {
				return (
					<PageWrapper title={title} gaPageTitle={gaPageTitle} >
						<Component {...props} />
					</PageWrapper>
				)
			} else {
				return (<Redirect
					to={{
						pathname: `/auth/welcome`,
						search: `?returnUrl=${location.pathname}`
					}}
				/>)
			}
		} else {
			return (
				<Redirect
					to={{
						pathname: `/auth/login`,
						search: `?returnUrl=${location.pathname}`
					}}
				/>
			)
		}
	}

	return (
		<Route
			{...rest}
			render={(props) =>
				renderRoute(props)
			}
		/>
	)
}

export default PrivateRoute